import React, { useMemo } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, Calendar } from '@material-ui/pickers';
import format from 'date-fns/format';

interface ScheduleCalendarProps {
  selectedDate: Date | null;
  onChange: (date: Date | null) => void;
  availableDates: string[]; // ["2026-08-01", "2026-08-02", ...]
}

const ScheduleCalendar: React.FC<ScheduleCalendarProps> = ({
  selectedDate,
  onChange,
  availableDates,
}) => {
  const availableDateSet = useMemo(() => new Set(availableDates), [
    availableDates,
  ]);

  const shouldDisableDate = (date: Date | null) => {
    if (!date) {
      return true;
    }

    const dateString = format(date, 'yyyy-MM-dd');
    return !availableDateSet.has(dateString);
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Calendar
        date={selectedDate ?? new Date()}
        onChange={onChange}
        shouldDisableDate={shouldDisableDate}
      />
    </MuiPickersUtilsProvider>
  );
};

export default ScheduleCalendar;
